class ContratoModel {

    id: number | null;
    codigo: number | null;
    edital: string | null;
    tipo: string | null;
    classificacao: string | null;

    constructor() {
        this.id = null;
        this.codigo = null;
        this.edital = null;
        this.tipo = null;
        this.classificacao = null;
    }

}

export default ContratoModel;
